import * as React from 'react';
import { HowAcademyWorksItem as THowAcademyWorksItem } from '~/common/types/types';
import { HowAcademyWorksItem } from '../components';
import * as styles from './how-academy-works-list.module.scss';

type Props = {
  items: THowAcademyWorksItem[];
};

const HowAcademyWorksList: React.FC<Props> = ({ items }) => (
  <ul className={styles.list}>
    {items.map((item) => (
      <HowAcademyWorksItem item={item} key={item.title} />
    ))}
  </ul>
);

export { HowAcademyWorksList };
